<app-navbar [title]="pageTitle">
	<a routerLink="./parms" class="btn btn-info me-2"> <i class="fas fa-sliders-h"></i> Parametry </a>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<div class="card">
	<div class="card-body row">
		<div class="col-sm-4">
			<label>Nazwa produktu</label>
			{{ offer?.name }}
		</div>
		<div class="col-sm-4">
			<label>Kod produktu</label>
			{{ offer?.code }}
		</div>
		<div class="col-sm-4">
			<label>ID produktu</label>
			{{ offer?.id }}
		</div>
		<div class="col-sm-4">
			<label>Ilośc terminów</label>
			{{ termsQuantity }}
		</div>
		<div class="col-sm-4">
			<label>Ilość dostępnych terminów</label>
			{{ termsAvaliableQuantity }}
		</div>
		<div class="col-sm-4">
			<label>Średnia Cena</label>
			{{ averagePrice }}
		</div>
	</div>
</div>

<table class="table table-striped table-hover text-end">
	<thead>
		<tr class="table-dark">
			<th rowspan="2">Dost.</th>
			<th rowspan="2">Data&nbsp;wyjazdu</th>
			<th rowspan="2">Data&nbsp;powrotu</th>
			<th rowspan="2">Ilość nocy</th>
			<th colspan="3" class="text-center">Uczestnicy / Rezerwacje</th>
			<!-- <th colspan="2" class="text-center">Cena</th> -->
			<th>Cena</th>
			<th rowspan="2">Przychód</th>
			<th rowspan="2">Koszty</th>
			<th rowspan="2">Zysk</th>
			<!-- <th rowspan="2">Status</th> -->
		</tr>
		<tr class="table-dark">
			<th>Potw.</th>
			<th>Opcj.</th>
			<th>Anul.</th>
			<th>Obecna</th>
			<!-- <th>Średnia</th> -->
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let term of terms">
			<td>
				<i class="fas fa-check text-success" *ngIf="term.available === '1'"></i>
				<i class="fas fa-times text-danger" *ngIf="term.available === '0'"></i>
			</td>
			<td>{{ term.from }}</td>
			<td>{{ term.to }}</td>
			<td>{{ term.nights }}</td>
			<td>{{ term.confirmedPeople }} / {{ term.confirmedReservations }}</td>
			<td>{{ term.optionalPeople }} / {{ term.optionalReservations }}</td>
			<td>{{ term.canceledPeople }} / {{ term.canceledReservations }}</td>
			<td>{{ term.priceNow }}</td>
			<!-- <td>{{ term.priceAvg }}</td> -->
			<td>{{ term.income }}</td>
			<td>{{ term.costs }}</td>
			<td>{{ term.profit }}</td>
			<!-- <td></td> -->
		</tr>
	</tbody>
</table>
